import useInView from "react-cool-inview";
const HealthCare = (props) => {
  const { observe, unobserve, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve(),
  });
  return (
    <div className="section-gap healthcare-main mt-3" ref={observe}>
      {inView && (
        <div className="container">
          <div className="row">
            <div
              className="col-md-6 healthcare-div1"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="row">
                <div className="col-md-12">
                  <div className="detail">
                    <h2 className="slot">{props.data.heading} * </h2>
                    <p className="healthcare-p text-light-blue pt-3">
                      {props.data.subHeading}*
                    </p>
                    <div className="bullets-points homecare-content">
                      <ul>
                        {props.data.bulletsPoints?.map((element, key) => (
                          <li className="d-flex" key={key}>
                            <span className="text-light-blue d-block bullet-position">
                              {element.title}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 ">
              <div className="healthcare-mobile-img-section">
                    <img
                    src="/how125.gif"
                      alt="above-fold-image"
                      className="healthcare-mobile-img"/>
              </div>
            </div>
          </div>
        </div>
      )}{" "}
    </div>
  );
};
export default HealthCare;